import { create } from "zustand";

const useStore = create((set) => ({
    name: '',
    updateName: (e) => set((state) => ({name: state.name = e})),
  }))

export default useStore;
